import React from "react"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"
import Invoices from "components/Invoices"

import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { INVOICING } from "constants/entitlements"

const InvoicesIndex = () => {
  return (
    <EntitlementPageGuard permission={INVOICING}>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | Facturas</title>
        </Helmet>
        <Container fluid>
          <Invoices />
        </Container>
      </div>
    </EntitlementPageGuard>
  )
}

export default InvoicesIndex
